// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8f13e254","455":"59c794da"}[chunkId] + ".chunk.js";
};